// extracted by mini-css-extract-plugin
module.exports = {"inputWrap":"FormSelect_inputWrap__E892D","rotation":"FormSelect_rotation__5klg2"};